import React from 'react'
import PropTypes from 'prop-types'
import { createContext } from 'src/util'
import noop from 'lodash/noop'
import { useContentRect } from 'src/hooks'
import PrintContext from './PrintContext'

/**
 * Context used to manage the current group
 */
export default createContext(Provider => {
  function GroundPlanContext({
    background,
    dndTargets,
    points,
    component,
    disabled,
    isPrinting,
    onPointAdd,
    onPointMove,
    onPointRemove,
    children,
  }) {
    // get plan ref
    const { ref: nodeRef } = PrintContext.use()

    // get plan dimensions
    const { height = 0, width = 0, x: planX = 0, y: planY = 0 } = useContentRect(nodeRef)

    // provide value to Provider component
    return (
      <Provider
        value={{
          nodeRef,
          height,
          width,
          planX,
          planY,
          background,
          dndTargets,
          points,
          component,
          disabled,
          isPrinting,
          onPointAdd,
          onPointMove,
          onPointRemove,
        }}
      >
        {children}
      </Provider>
    )
  }

  GroundPlanContext.defaultProps = {
    points: [],
    onPointAdd: noop,
    onPointMove: noop,
    onPointRemove: noop,
  }

  GroundPlanContext.propTypes = {
    background: PropTypes.shape({
      url: PropTypes.string,
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    dndTargets: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string), PropTypes.func]),
    points: PropTypes.array,
    component: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    isPrinting: PropTypes.bool,
    onPointAdd: PropTypes.func,
    onPointMove: PropTypes.func,
    onPointRemove: PropTypes.func,
    children: PropTypes.node,
  }

  return GroundPlanContext
})
